import React from 'react'
import { Icon } from '@paypalcorp/ppods-react'
const externalIcon = (
  <Icon
    name="arrow-square-in"
    size="18"
    aria-label="arrow-square-in"
    aria-hidden="true"
    color="#696969"
    style={{ position: 'relative', top: '2px' }}
  />
)

export const menuItems = [
  {
    label: 'Home',
    icon: 'home',
    path: '/',
    hasChevron: false,
    target: '_self',
  },
  {
    label: 'Partner Setup',
    icon: 'navigate',
    path: '/partner-setup',
    hasChevron: false,
    target: '_self',
  },
  {
    label: 'Apps & Credentials',
    icon: 'registration-doc',
    path: '/applications/ENVIRONMENT',
    hasChevron: false,
    target: '_self',
  },
  {
    label: 'Testing Tools',
    icon: 'desktop',
    hasChevron: true,
    menuKey: 'testing-tools', // <-- add unique key
    submenu: [
      {
        label: 'Sandbox Accounts',
        path: '/accounts',
        target: '_self',
        parentTitle: 'Testing Tools',
      },
      {
        label: 'Sandbox Notifications',
        path: '/notifications',
        target: '_self',
        parentTitle: 'Testing Tools',
      },
      {
        label: 'Webhook Simulator',
        path: '/webhooksSimulator',
        target: '_self',
        parentTitle: 'Testing Tools',
      },
    ],
  },
  {
    label: 'Event Logs',
    icon: 'book-open',
    hasChevron: true,
    menuKey: 'event-logs', // <-- add unique key
    submenu: [
      {
        label: 'API Calls',
        path: '/api-calls/ENVIRONMENT',
        target: '_self',
        parentTitle: 'Event Logs',
      },
      {
        label: 'Webhook Events',
        path: '/webhooks/ENVIRONMENT',
        target: '_self',
        parentTitle: 'Event Logs',
      },
      {
        label: 'Error Logs',
        path: '/errors/ENVIRONMENT',
        target: '_self',
        parentTitle: 'Event Logs',
      },
      {
        label: 'Transactions',
        path: '/transactions/ENVIRONMENT',
        target: '_self',
        parentTitle: 'Event Logs',
      },
    ],
  },
  {
    icon: 'book-open',
    label: 'Upgrade',
    path: '/upgrade-your-apps',
  },
  {
    label: 'divider',
  },
]
export const globalMenuItems = [
  {
    label: 'Docs',
    icon: 'document',
    hasChevron: true,
    menuKey: 'docs',
    submenu: [
      {
        label: 'Online',
        path: 'https://developer.paypal.com/docs/online/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'In-person',
        path: 'https://developer.paypal.com/docs/in-person/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Multiparty',
        path: 'https://developer.paypal.com/docs/multiparty/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: '3rd-party',
        path: 'https://developer.paypal.com/docs/3rd-party/',
        target: '_blank',
        icon: externalIcon,
      },

      {
        label: 'Payouts',
        path: 'https://developer.paypal.com/docs/payouts/',
        target: '_blank',
        icon: externalIcon,
      },

      {
        label: 'Disputes',
        path: 'https://developer.paypal.com/docs/disputes/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Reports',
        path: 'https://developer.paypal.com/docs/reports/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Identity',
        path: 'https://developer.paypal.com/docs/log-in-with-paypal/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Tracking',
        path: 'https://developer.paypal.com/docs/tracking/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Docs Archive',
        path: 'https://developer.paypal.com/docs/archive',
        target: '_blank',
        icon: externalIcon,
      },
    ],
  },
  {
    label: 'APIs & SDKs',
    icon: 'code',
    hasChevron: true,
    menuKey: 'apis-sdks',
    submenu: [
      {
        label: 'REST APIs',
        path: 'https://developer.paypal.com/api/rest/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Server SDKs',
        path: 'https://developer.paypal.com/serversdk/http/getting-started/how-to-get-started/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Javascript SDK',
        path: 'https://developer.paypal.com/sdk/js/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Mobile SDKs',
        path: 'https://developer.paypal.com/sdk/mobile/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'NVP/SOAP APIs',
        path: 'https://developer.paypal.com/api/nvp-soap/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Donate SDK',
        path: 'https://developer.paypal.com/sdk/donate/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Braintree GraphQL API',
        path: 'https://graphql.braintreepayments.com/',
        target: '_blank',
        icon: externalIcon,
      },
    ],
  },
  {
    label: 'Tools',
    icon: 'tools',
    hasChevron: true,
    menuKey: 'tools',
    submenu: [
      {
        label: 'Upgrade hub',
        path: 'https://developer.paypal.com/upgrade/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Agent toolkit',
        path: 'https://www.paypal.ai/docs/tools/agent-toolkit-quickstart',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'MCP Server',
        path: 'https://www.paypal.ai/docs/tools/mcp-quickstart',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'VS Code extension',
        path: 'https://developer.paypal.com/tools/vscode/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Sandbox testing guide',
        path: 'https://developer.paypal.com/api/rest/sandbox/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Negative testing',
        path: 'https://developer.paypal.com/api/rest/sandbox/negative-testing/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Credit card generator',
        path: 'https://developer.paypal.com/api/rest/sandbox/card-testing/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Demo portal',
        path: 'https://demo.paypal.com/us/demo/home',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Webhooks',
        path: 'https://developer.paypal.com/api/rest/webhooks/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'Secure file transfer',
        path: 'https://developer.paypal.com/tools/dropzone/',
        target: '_blank',
        icon: externalIcon,
      },
      {
        label: 'API status',
        path: 'https://www.paypal-status.com/api/production',
        target: '_blank',
        icon: externalIcon,
      },
    ],
  },
  {
    label: 'Video Library',
    icon: 'movie',
    path: 'https://developer.paypal.com/video/home',
    hasChevron: false,
    target: '_blank',
  },
  {
    label: 'Help',
    icon: 'help',
    path: 'https://developer.paypal.com/docs/support',
    hasChevron: false,
    target: '_blank',
  },
]
